module.exports = __webpack_public_path__ + "static/media/mazda-go-drive.021c7277.png";